import React, { useContext } from 'react';

import { VerifyPersonalInfoContents } from '../../components';
import { IdentityProvider } from '../../context';

import { NewWillContext } from './new-will-provider';


export function NewWillVerifyPersonalInfoScreen() {
  const { update } = useContext(NewWillContext);

  return (
    <IdentityProvider>
      <VerifyPersonalInfoContents 
        resource="wills" 
        steps={6} 
        nextPath="../asset-distribution" 
        updateEntity={update}
      />
    </IdentityProvider>
  );
}

